import Modal from "react-bootstrap/Modal";
import React, { useState, useEffect } from "react";
import axios from "axios";
import "../../Style/Checkbox.scss";
import "../../Style/__button.scss";
import "../../Style/InsertModal.scss";
import "../../Style/FiscalCashRegisterForm.scss";
import { errorAlert, handleSuccess } from "../../Components/Alerts";
import { ApiLink } from "../../APILink/ApiLink";
import authHeader from "../../Auth/authHeader";
import LoginUserDetailed from "../../Auth/LoginUserDetailed";
import TextField from "@mui/material/TextField";
import AddBoxIcon from "@mui/icons-material/AddBox";
import { AddElementsButton } from "../../Components/AddElementsButton";
import Autocomplete from "@mui/material/Autocomplete";
import { getCompanyUnits } from "../../GetData/CompanyUnitsData";
import ATKOnboardingWizard from "./ATKOnboardingWizard";

function InsertFiscalCashRegister(props) {
  const [hash, setHash] = useState("");
  const [companyID, setCompanyID] = useState();
  const [posID, setPosID] = useState();
  const [location, setLocation] = useState("");
  const [description, setDescription] = useState("");
  const [isActive, setIsActive] = useState(true);
  const [unitID, setUnitID] = useState(0);
  const [atkBranchID, setAtkBranchID] = useState("");
  const [externalModuleCode, setExternalModuleCode] = useState("");
  const [atkPOSID, setAtkPOSID] = useState("");
  const [atkAppicationID, setAtkAppicationID] = useState("");
  const [atkFiscalizationNumber, setAtkFiscalizationNumber] = useState("");
  const [atkSEFCode, setAtkSEFCode] = useState("");
  const [atkPrivateKeyPemEncrypted, setAtkPrivateKeyPemEncrypted] = useState("");
  const [atkSignedCertificatePem, setAtkSignedCertificatePem] = useState("");

  const [company, setCompany] = useState([]);
  const [paymentsAccounts, setPaymentsAccounts] = useState([]);
  const [companyUnits, setCompanyUnits] = useState([]);
  const [externalModules, setExternalModules] = useState([]);

  // ATK Onboarding states
  const [showATKSections, setShowATKSections] = useState(false);

  const email = LoginUserDetailed(); // ndryshoni me emailin e përdoruesit të kyqur
  const headers = authHeader();

  /**
   * Handle callback from ATK Onboarding Wizard
   * Populates ATK fields automatically when onboarding completes
   */
  const handleATKOnboardingComplete = (onboardingData) => {
    setAtkBranchID(onboardingData.atkBranchID);
    setAtkPOSID(onboardingData.atkPOSID);
    setAtkAppicationID(onboardingData.atkAppicationID);
    setAtkFiscalizationNumber(onboardingData.atkFiscalizationNumber);
    setAtkSEFCode(onboardingData.atkSEFCode);
    setAtkPrivateKeyPemEncrypted(onboardingData.atkPrivateKeyPemEncrypted);
    setAtkSignedCertificatePem(onboardingData.atkSignedCertificatePem);
    setShowATKSections(true);
    handleSuccess("Onboarding-u u krye me sukses! Fushat plotësohen automatikisht.");
  };

  const handleSubmit = (event) => {
    event.preventDefault();
    const stateData = {
      CashRegisterHash: hash,
      POSID: posID,
      CompanyID: companyID,
      LocationName: location,
      Description: description,
      CreatedByUser: email,
      IsActive: isActive,
      UnitID:unitID,
      ATKBranchID: atkBranchID ? Number(atkBranchID) : 0,
      ExternalModuleCode: externalModuleCode || null,
      ATKPOSID: atkPOSID ? Number(atkPOSID) : 0,
      ATKAppicationID: atkAppicationID ? Number(atkAppicationID) : 0,
      ATKFiscalizationNumber: atkFiscalizationNumber || null,
      ATKSEFCode: atkSEFCode || null,
      ATKPrivateKeyPemEncrypted: atkPrivateKeyPemEncrypted || null,
      ATKSignedCertificatePem: atkSignedCertificatePem || null,
    };
    axios
      .post(ApiLink.API_URL + "FiscalCashRegister", stateData, { headers })
      .then((response) => {
        // console.log(response.data);
        handleSuccess("P.O.S-i u insertua me sukses");
        setHash("");
        setPosID();
        setCompanyID();
        setLocation("");
        setDescription("");
        setIsActive(true);
        setUnitID(0);
        setExternalModuleCode("");
        setAtkPOSID("");
        setAtkAppicationID("");
        setAtkFiscalizationNumber("");
        setAtkSEFCode("");
        setAtkPrivateKeyPemEncrypted("");
        setAtkSignedCertificatePem("");
        props.onHide();
        props.refreshData(); // Thirrja e funksionit per refresh te dhenave
      })
      .catch((error) => {
        console.error("FiscalCashRegister create failed:", error?.response?.data || error);
        errorAlert("Gabim gjatë ruajtjes së P.O.S-it.", error);
      });
  };

  const handleClose = () => {
    // Ky funksion do të përdoret për të mbyllur modalin
    props.onHide();
    setHash("");
    setPosID();
    setCompanyID();
    setLocation("");
    setDescription("");
    setIsActive(true);
    setUnitID(0);
    setAtkBranchID("");
    setExternalModuleCode("");
    setAtkPOSID("");
    setAtkAppicationID("");
    setAtkFiscalizationNumber("");
    setAtkSEFCode("");
    setAtkPrivateKeyPemEncrypted("");
    setAtkSignedCertificatePem("");
    setShowATKSections(false);
  };

  useEffect(() => {
    Promise.all([
      axios.get(ApiLink.API_URL + "companies", { headers }),
      axios.get(ApiLink.API_URL + "License/getSystemModule", { headers }),
    ])
      .then(([companyResponse, moduleResponse]) => {
        setCompany(companyResponse.data || []);
        const onlyExternalModules = (moduleResponse.data || []).filter(
          (item) => Number(item?.IsExternal) === 1 && Number(item?.IsActive) === 1,
        );
        setExternalModules(onlyExternalModules);
      })
      .catch((error) => {
        console.error(error);
      });
  }, []);

  // const fetchPaymentsAccount = async (id) => {
  //     try {
  //         const response = await axios.get(ApiLink.API_URL + 'Accounts/accountByLedgerandCompany', { headers, params: { ledger: 101, id: id } });
  //         setPaymentsAccounts(response.data);
  //     } catch (error) {
  //         errorAlert("Gabim në kërkesë:", error);

  //         if (error.response && error.response.data && error.response.data.errorMessage) {
  //             errorAlert(`Gabim në marrjen e të dhënave: ${error.response.data.errorMessage}`);
  //         } else if (error.message) {
  //             errorAlert(`Gabim: ${error.message}`);
  //         } else {
  //             errorAlert("Gabim i panjohur në kërkesë. Shih konsolën për detaje.");
  //         }
  //     }
  // };

  const fetchPaymentsAccount = async (id) => {
    try {
      // Thirrja e parë (Accounts)
      const response = await axios.get(
        ApiLink.API_URL + "Accounts/accountByLedgerandCompany",
        {
          headers,
          params: { ledger: 101, id: id },
        },
      );
      setPaymentsAccounts(response.data);

      //marrja e njesive organizative
      const units = await getCompanyUnits(id);
      setCompanyUnits(units); 
    } catch (error) {
      // Logjika jote ekzistuese për error alert
      errorAlert("Gabim në kërkesë:", error);
      if (
        error.response &&
        error.response.data &&
        error.response.data.errorMessage
      ) {
        errorAlert(
          `Gabim në marrjen e të dhënave: ${error.response.data.errorMessage}`,
        );
      } else if (error.message) {
        errorAlert(`Gabim: ${error.message}`);
      } else {
        errorAlert("Gabim i panjohur.");
      }
    }
  };

  const fetchNextATKPOSID = async (id) => {
    try {
      const response = await axios.get(
        ApiLink.API_URL + `FiscalCashRegister/next-atk-pos-id/${id}`,
        { headers },
      );
      setAtkPOSID(response.data?.ATKPOSID ?? "");
    } catch (error) {
      console.error("Failed to fetch next ATK POS ID:", error?.response?.data || error);
      setAtkPOSID("");
      errorAlert("Gabim gjatë marrjes së ATK POS ID.", error);
    }
  };

  //Per ta zgjedhur kompanin
  const handleAutocompleteChangeCompany = (event, value) => {
    if (value) {
      setCompanyID(value.CompanyID);
      setPosID();
      fetchPaymentsAccount(value.CompanyID);
      fetchNextATKPOSID(value.CompanyID);
    } else {
      setCompanyID();
      setPosID();
      setAtkPOSID("");
    }
  };

  const defaultPropsCompany = {
    options: company,
    getOptionLabel: (option) => option.CompanyName || "",
  };

  const handleAutocompletePaymentOptions = (event, value) => {
    if (value) {
      setPosID(value.AccountID);
    } else {
      setPosID();
    }
  };

  const defaultPropsPaymentOptions = {
    options: paymentsAccounts,
    getOptionLabel: (option) => option.AccountName || "",
  };

  //Per ta zgjedhur njesin e kompanis
  const handleAutocompleteChangeCompanyUnit = (event, value) => {
    if (value) {
      setUnitID(value.UnitID);
    } else {
      setUnitID("");
    }
  };

  const defaultPropsCompanyUnit = {
    options: companyUnits,
    getOptionLabel: (option) => option.UnitName || "",
  };

  const defaultPropsExternalModule = {
    options: externalModules,
    getOptionLabel: (option) => option.ModuleName || "",
  };

  const handleAutocompleteExternalModule = (event, value) => {
    if (value) {
      setExternalModuleCode(value.ModuleCode || "");
    } else {
      setExternalModuleCode("");
    }
  };

  return (
    <Modal
      {...props}
      size="xl"
      dialogClassName="fcr-modal"
      aria-labelledby="contained-modal-title-vcenter"
      centered
    >
      <form onSubmit={handleSubmit} className="fcr-form">
        <Modal.Header className="fcr-form__header">
          <div>
            <Modal.Title id="contained-modal-title-vcenter" className="fcr-form__title">
              Krijo P.O.S. të ri
            </Modal.Title>
            <p className="fcr-form__subtitle">
              Konfigurimi i arkës, kompanisë dhe të dhënave fiskale ATK.
            </p>
          </div>
          <span className="fcr-form__badge">Insertim</span>
        </Modal.Header>
        <Modal.Body className="fcr-form__body">
          <section className="fcr-form__section">
            <div className="fcr-form__section-header">
              <span>1</span>
              <div>
                <h4>Identifikimi i P.O.S</h4>
                <p>Zgjedh kompaninë, arkën dhe lokacionin operativ.</p>
              </div>
            </div>
            <div className="fcr-form__grid fcr-form__grid--two">
              <TextField
                fullWidth
                id="HashCode"
                label="Hash Code"
                variant="outlined"
                type="text"
                name="HashCode"
                autoComplete="off"
                required
                value={hash}
                onChange={(event) => setHash(event.target.value)}
              />
              <TextField
                fullWidth
                id="LocationName"
                label="Lokacioni P.O.S-it"
                variant="outlined"
                type="text"
                name="LocationName"
                autoComplete="off"
                value={location}
                onChange={(event) => setLocation(event.target.value)}
              />
              <Autocomplete
                fullWidth
                {...defaultPropsCompany}
                id="company-select"
                includeInputInList
                onChange={handleAutocompleteChangeCompany}
                renderInput={(params) => (
                  <TextField {...params} label="Zgjedh kompaninë" required />
                )}
              />
              <Autocomplete
                fullWidth
                {...defaultPropsPaymentOptions}
                id="cash-register-select"
                includeInputInList
                onChange={handleAutocompletePaymentOptions}
                renderInput={(params) => (
                  <TextField {...params} label="Zgjedh arkën" required />
                )}
              />
              <Autocomplete
                fullWidth
                {...defaultPropsCompanyUnit}
                id="company-unit-select"
                includeInputInList
                onChange={handleAutocompleteChangeCompanyUnit}
                renderInput={(params) => (
                  <TextField {...params} label="Njësia organizative" />
                )}
              />
              <Autocomplete
                fullWidth
                {...defaultPropsExternalModule}
                id="external-module-select"
                includeInputInList
                onChange={handleAutocompleteExternalModule}
                value={
                  externalModules.find(
                    (option) => (option.ModuleCode || "") === externalModuleCode,
                  ) || null
                }
                renderInput={(params) => (
                  <TextField {...params} label="Moduli i jashtëm" />
                )}
              />
            </div>
          </section>

          {/* ATK Onboarding Button - between Section 1 and 2 */}
          <section className="fcr-form__section">
            <ATKOnboardingWizard
              onComplete={handleATKOnboardingComplete}
              branchId={atkBranchID}
              initialATKPOSID={atkPOSID}
            />
          </section>

          <section
            className="fcr-form__section"
            style={{ display: showATKSections ? "block" : "none" }}
          >
            <div className="fcr-form__section-header">
              <span>2</span>
              <div>
                <h4>Konfigurimi fiskal ATK</h4>
                <p>Plotëso identifikuesit fiskalë të kërkuar për fiskalizim.</p>
              </div>
            </div>
            <div className="fcr-form__grid fcr-form__grid--four">
              <TextField
                fullWidth
                id="ATKPOSID"
                label="ATK POS ID"
                variant="outlined"
                type="number"
                name="ATKPOSID"
                autoComplete="off"
                value={atkPOSID}
                onChange={(event) => setAtkPOSID(event.target.value)}
                InputProps={{ readOnly: showATKSections }}
              />
              <TextField
                fullWidth
                id="ATKAppicationID"
                label="ATK Application ID"
                variant="outlined"
                type="number"
                name="ATKAppicationID"
                autoComplete="off"
                value={atkAppicationID}
                onChange={(event) => setAtkAppicationID(event.target.value)}
                InputProps={{ readOnly: showATKSections }}
              />
              <TextField
                fullWidth
                id="ATKFiscalizationNumber"
                label="ATK Fiscalization Number"
                variant="outlined"
                type="number"
                name="ATKFiscalizationNumber"
                autoComplete="off"
                value={atkFiscalizationNumber}
                onChange={(event) => setAtkFiscalizationNumber(event.target.value)}
                InputProps={{ readOnly: showATKSections }}
              />
              <TextField
                fullWidth
                id="ATKSEFCode"
                label="ATK SEF Code"
                variant="outlined"
                type="text"
                name="ATKSEFCode"
                autoComplete="off"
                value={atkSEFCode}
                onChange={(event) => setAtkSEFCode(event.target.value)}
                InputProps={{ readOnly: showATKSections }}
              />
            </div>
          </section>

          <section
            className="fcr-form__section"
            style={{ display: showATKSections ? "block" : "none" }}
          >
            <div className="fcr-form__section-header">
              <span>3</span>
              <div>
                <h4>Certifikatat dhe çelësat</h4>
                <p>Vendos private key të enkriptuar dhe certifikatën e nënshkruar.</p>
              </div>
            </div>
            <div className="fcr-form__grid fcr-form__grid--two">
              <TextField
                fullWidth
                id="ATKPrivateKeyPemEncrypted"
                label="ATK Private Key Pem Encrypted"
                variant="outlined"
                name="ATKPrivateKeyPemEncrypted"
                autoComplete="off"
                multiline
                minRows={5}
                value={atkPrivateKeyPemEncrypted}
                onChange={(event) => setAtkPrivateKeyPemEncrypted(event.target.value)}
                InputProps={{ readOnly: showATKSections }}
              />
              <TextField
                fullWidth
                id="ATKSignedCertificatePem"
                label="ATK Signed Certificate Pem"
                variant="outlined"
                name="ATKSignedCertificatePem"
                autoComplete="off"
                multiline
                minRows={5}
                value={atkSignedCertificatePem}
                onChange={(event) => setAtkSignedCertificatePem(event.target.value)}
                InputProps={{ readOnly: showATKSections }}
              />
            </div>
          </section>

          <section className="fcr-form__section">
            <div className="fcr-form__section-header">
              <span>4</span>
              <div>
                <h4>Statusi dhe përshkrimi</h4>
                <p>Kontrollo nëse P.O.S është aktiv dhe shto shënime të brendshme.</p>
              </div>
            </div>
            <div className="fcr-form__grid">
              <TextField
                fullWidth
                id="Description"
                label="Përshkrimi"
                variant="outlined"
                type="text"
                autoComplete="off"
                name="Description"
                multiline
                minRows={3}
                value={description}
                onChange={(event) => setDescription(event.target.value)}
              />
            </div>
          </section>
        </Modal.Body>
        <div className="fcr-form__footer">
          <label className="fcr-form__switch">
            <input
              type="checkbox"
              checked={isActive}
              onChange={(event) => setIsActive(event.target.checked)}
            />
            <span></span>
            P.O.S aktiv
          </label>
          <div className="fcr-form__actions">
            <button type="button" className="fcr-form__secondary-button" onClick={handleClose}>
              Anulo
            </button>
            <button type="submit" className="fcr-form__primary-button">
              Ruaj ndryshimet
            </button>
          </div>
        </div>
      </form>
    </Modal>
  );
}

export default function InsertData(props) {
  const [modalShow, setModalShow] = React.useState(false);

  const handleRefreshData = () => {
    props.fetchData(); // Thirrja e funksionit per refresh te dhenave
  };
  return (
    <div>
      {props.type === "text" ? (
        <AddElementsButton
          text="Krijo P.O.S"
          onClick={() => setModalShow(true)}
          icon="bi bi-upc-scan"
          className="button-68"
        />
      ) : props.type === "insert" ? (
        <AddElementsButton
          text="Krijo P.O.S"
          onClick={() => setModalShow(true)}
          icon="bi bi-upc-scan"
          className="button-15"
        />
      ) : props.type === "menu" ? (
        <i class="bi bi-upc-scan" onClick={() => setModalShow(true)}></i>
      ) : (
        <AddBoxIcon
          style={{ height: "29px", color: "black" }}
          onClick={() => setModalShow(true)}
        />
      )}
      <InsertFiscalCashRegister
        show={modalShow}
        onHide={() => setModalShow(false)}
        refreshData={handleRefreshData}
      />
    </div>
  );
}
